<template>
  <hi-page>
    <hi-page-column card width="25vw">
      <template v-slot:header>
        <hi-row flex>
          <div class="flex-grow-1"><di-new-contact /></div>
        </hi-row>
      </template>
      <contact-list />
    </hi-page-column>
    <router-view></router-view>
    <!--    <hi-sub-page v-if="!currentCampaign">-->
    <hi-sub-page v-if="false">
      <hi-page-column card width="50vw" fix-width>
        <hi-row v-for="event in sgEvents" :key="event.id">
          <span class="ui-text">{{ event.sg_message_id }} - </span>
          <span class="ui-text">{{ event.id }}</span
          ><br />
          <span class="ui-text">
            {{ getTime(event.timestamp) | friendlyTime }}
          </span>
          <span class="ui-text">| event </span>
          <span>{{ event.event }}</span>
          <span class="ui-text">| cat </span>
          <span>{{ event.hive_cat }}</span>
          <span class="ui-text">| type </span>
          <span>{{ event.hive_type }}</span>
          <span class="ui-text">| email </span>
          <span>{{ event.email }}</span>
        </hi-row>
      </hi-page-column>
    </hi-sub-page>
  </hi-page>
</template>
<script>
import HiPage from "@/components/scaffold/HiPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiRow from "@/components/scaffold/HiRow";
import HiSubPage from "@/components/scaffold/HiSubPage";
// import { db } from "@/db";
import moment from "moment";
// import { mapActions, mapGetters } from "vuex";
import ContactList from "@/components/contacts/ContactList";
import DiNewContact from "@/components/contacts/DiNewContact";

export default {
  name: "Contacts",
  components: {
    DiNewContact,
    ContactList,
    HiSubPage,
    HiRow,
    HiPageColumn,
    HiPage
    // LeadDetails,
    // LeadComments
  },
  data() {
    return {};
  },
  methods: {
    // ...mapActions("edm", { bindCampaignList: "bindCampaignList" }),
    // selectCampaign(campaign) {
    //   this.campaign = campaign;
    //   this.$router.replace({ path: `/edm/${campaign.id}` });
    // },
    getTime(ts) {
      return moment.unix(ts).toDate();
    }
  },
  firestore: {},
  computed: {},
  created() {},
  destroyed() {}
};
</script>
<style></style>
